import React, { Suspense, useEffect, useState } from "react";
import { ThemeProvider } from "styled-components";
import { I18nextProvider, Trans, useTranslation } from "react-i18next";
import i18n from "../i18n";
import { CssBaseline } from "@mui/material";
import { ErrorBoundary } from "@sentry/react";
// Modify react behavior so we don't get exceptions when using Google Chrome Translate
import googleTranslateHack from "../google-translate-hack";
import PortalProvider from "../Providers/PortalProvider";
import { StyledEngineProvider, ThemeProvider as MUIThemeProvider, } from "@mui/material/styles";
import { StylesProvider } from "@mui/styles";
import { AssetResolverProvider, defaultAssetResolver, } from "@/react/Webshop/providers/AssetResolver";
import { WebshopApiClientProvider } from "@/react/Webshop/providers/WebshopApiClientProvider";
import { ShoppingCartApiClientProvider } from "@/react/Webshop/providers/ShoppingCartClientProvider";
import StylesThemeProvider from "@mui/styles/ThemeProvider";
import jQuery from "jquery";
import { createThemeFromPalette, styledTheme } from "./Common/theme";
import generateClassName from "./generateClassName";
googleTranslateHack();
const AppWrapper = ({ children }) => {
    const [state, setState] = useState(styledTheme);
    useEffect(() => {
        // Hack, use jQuery custom components to update the theme:
        if (typeof jQuery != "undefined") {
            const handleColorUpdate = (_, colors) => {
                setState((state) => (Object.assign(Object.assign({}, state), { theme: Object.assign(Object.assign({}, state.theme), { colors: colors.colors }), MUITheme: createThemeFromPalette(colors.MUIColors) })));
            };
            jQuery(document).on("colorUpdate", {
                foo: "bar",
            }, handleColorUpdate);
            return () => {
                jQuery(document).off("colorUpdate", handleColorUpdate);
            };
        }
    }, []);
    return (React.createElement(Suspense, { fallback: React.createElement("div", null, "Loading...") },
        React.createElement(WebshopApiClientProvider, null,
            React.createElement(ShoppingCartApiClientProvider, null,
                React.createElement(PortalProvider, null,
                    React.createElement(I18nextProvider, { i18n: i18n },
                        React.createElement(TranslationWrapper, null,
                            React.createElement(MyErrorBoundary, null,
                                React.createElement(AssetResolverProvider, { resolver: defaultAssetResolver },
                                    React.createElement(StylesProvider, { injectFirst: true, generateClassName: generateClassName },
                                        React.createElement(StyledEngineProvider, null,
                                            React.createElement(MUIThemeProvider, { theme: state.MUITheme },
                                                React.createElement(StylesThemeProvider, { theme: state.MUITheme },
                                                    React.createElement(CssBaseline, null),
                                                    React.createElement(ThemeProvider, { theme: state.theme }, children))))))))))))));
};
const TranslationWrapper = ({ children }) => {
    // It's peak season -24, and I don't want to upgrade i18next.
    // There is a bug if the first translation is a Trans component,
    // it will claim i18 next is not initialized.
    // Calling the hook seem to be enough to initialize it
    useTranslation();
    return children;
};
const MyErrorBoundary = ({ children }) => {
    if (process.env.NODE_ENV !== "production") {
        return React.createElement(React.Fragment, null, children);
    }
    return React.createElement(ErrorBoundary, { fallback: React.createElement(ErrorMessage, null) }, children);
};
const ErrorMessage = () => {
    var _a, _b, _c;
    const email = ((_c = (_b = (_a = window.NTLF_CONFIG) === null || _a === void 0 ? void 0 : _a.portal) === null || _b === void 0 ? void 0 : _b.contactInfo) === null || _c === void 0 ? void 0 : _c.email) || "";
    return (React.createElement("div", null,
        React.createElement("h1", null,
            React.createElement(Trans, null, "An error occurred")),
        React.createElement("p", null,
            React.createElement(Trans, null, "Please refresh the page to try again.")),
        React.createElement("p", null,
            React.createElement(Trans, { values: { errorEmailAddress: email }, components: { a: React.createElement("a", { href: `mailto:${email}` }) } }, "If you keep getting the error, please let us know at <a>{{errorEmailAddress}}</a>"))));
};
export default AppWrapper;
